module.exports = require("keytar");